import {observer} from "mobx-react"
import {useNavigate} from "react-router"
import {useState} from "react"
import {DialogStore, growlStore, userCreateStore} from "../../../store"
import {ModalDialog, Page, PageContentTitle} from "../../ui"
import {UserForm} from "./UserForm";

const UserCreatePage = observer(function UserCreatePage() {
    const navigate = useNavigate()
    const [cancelDialog] = useState(new DialogStore())
    return <Page cssSuffix={"user"}
                 breadcrumb={[
                     {
                         link: `/ums/user`,
                         label: 'Benutzer'
                     },
                     {
                         link: '#',
                         label: 'Benutzer anlegen'
                     }
                 ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        userCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate(`/ums/user`)
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Entwurf verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie diesen Entwurf löschen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${userCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !userCreateStore.valid,
                    action: async () => {
                        const result = await userCreateStore.create()
                        if (result) {
                            userCreateStore.reset()
                            growlStore.add({
                                message: 'Der Benutzer wurde erfolgreich hinzugefügt',
                                autoclose: false,
                                closable: true
                            })
                            navigate(`/ums/user`)
                        }
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: userCreateStore.creating,
                    action: () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >Neuen Benutzer anlegen</PageContentTitle>
        <UserForm
            saving={userCreateStore.creating}
            data={userCreateStore.formData}
            onValidate={() => userCreateStore.validate().finally()}
            onChange={v => {
                userCreateStore.formData = v
            }}
        />
    </Page>
})

export {
    UserCreatePage
}
